import { AddressDetails } from '../../shared/models/address.types';
import { ContactDetails } from '../../shared/models/contact.types';

export type SupervisorStatus = 'active' | 'inactive';
export type SupervisorApprovalStatus = 'pending';

export interface SupervisorAgencyAssignment {
  id: string;
  name: string;
  city?: string;
  area?: string;
}

export interface SupervisorModel {
  id: string;
  name: string;
  code: string;
  email: string;
  contact: ContactDetails;
  phoneDisplay: string;
  assignedAgencies: SupervisorAgencyAssignment[];
  address: AddressDetails;
  city: string;
  status: SupervisorStatus;
  createdAt: string;
}

export interface SupervisorApprovalRequestModel {
  id: string;
  name: string;
  email: string;
  contact: ContactDetails;
  requestedAgency: SupervisorAgencyAssignment;
  requestDate: string;
  approvalStatus: SupervisorApprovalStatus;
}

export interface SupervisorUpsertPayload {
  name: string;
  code: string;
  status: SupervisorStatus;
  password?: string;
  contact: ContactDetails;
  address: AddressDetails;
  assignedAgencies: SupervisorAgencyAssignment[];
}

export interface SupervisorRecord extends SupervisorModel {}

export interface SupervisorApprovalRequestRecord extends SupervisorApprovalRequestModel {}

export function toSupervisorRecord(id: string, payload: SupervisorUpsertPayload, current?: SupervisorRecord): SupervisorRecord {
  const phoneDisplay = formatPhoneDisplay(payload.contact.phone);

  return {
    id,
    name: payload.name,
    code: payload.code,
    email: payload.contact.email,
    contact: payload.contact,
    phoneDisplay,
    assignedAgencies: payload.assignedAgencies,
    address: payload.address,
    city: payload.address.locality,
    status: payload.status,
    createdAt: current?.createdAt ?? new Date().toISOString()
  };
}

export function formatPhoneDisplay(phone: ContactDetails['phone']): string {
  const dialCode = phone.dialCode ? `+${phone.dialCode}` : '';
  return [dialCode, phone.number].filter(Boolean).join(' ').trim();
}
